module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "visual-process"
  }, [_c('h3', [_vm._v(_vm._s(_vm.produktnaam) + "sverzekering")]), _vm._v(" "), _c('div', {
    staticClass: "grid-container"
  }, [_c('step1schademelden-component', {
    attrs: {
      "ctx": _vm.ctx,
      "schademeldenurl": _vm.schademeldenurl
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "visual-item"
  }, [_c('div', {
    staticClass: "hexagon-thick"
  }, [_c('p', {
    staticClass: "icon icon-archive clean"
  })]), _vm._v(" "), _c('h4', [_vm._v("In behandeling")]), _vm._v(" "), _c('p', [_vm._v("Wij nemen uw schademelding binnen 48 uur in behandeling en dragen het dossier over aan de rechtsbijstandsverzekeraar.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#behandelingmodal"
    }
  }, [_vm._v("Lees meer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "visual-item"
  }, [_c('div', {
    staticClass: "hexagon-thick"
  }, [_c('p', {
    staticClass: "icon icon-check clean"
  })]), _vm._v(" "), _c('h4', [_vm._v("Afgehandeld")]), _vm._v(" "), _c('p', [_vm._v("Wij hebben uw dossier gesloten. De behandeling van het dossier verloopt rechtstreeks tussen u en uw rechtsbijstandsverzekeraar.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "behandelingmodal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("In behandeling")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("x")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("Binnen 2 werkdagen na ontvangst van de melding laat de rechtsbijstandsverzekeraar weten of er dekking is. Als er dekking is neemt een jurist uiterlijk binnen 5 werkdagen inhoudelijk contact met u op.")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-modal-close",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("OK")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4459535f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/schade/rechtsbijstand.vue
// module id = 90
// module chunks = 0